
define('text!modules/360-feedback/states/360-feedback-external-result-accepted/template.html',[],function () { return '<div class=u-textAlignCenter><h3 translate=360_FEEDBACK.EXTERNAL.ACCEPTED_HEADER></h3><div translate=360_FEEDBACK.EXTERNAL.ACCEPTED_BODY></div></div>';});

